import { render, staticRenderFns } from "./ImportsList.vue?vue&type=template&id=05c98f98&scoped=true"
import script from "./ImportsList.vue?vue&type=script&lang=js"
export * from "./ImportsList.vue?vue&type=script&lang=js"
import style0 from "./ImportsList.vue?vue&type=style&index=0&id=05c98f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c98f98",
  null
  
)

export default component.exports